import { render, staticRenderFns } from "./BalanceIssues.vue?vue&type=template&id=018e0973&scoped=true&"
import script from "./BalanceIssues.vue?vue&type=script&lang=js&"
export * from "./BalanceIssues.vue?vue&type=script&lang=js&"
import style0 from "./BalanceIssues.vue?vue&type=style&index=0&id=018e0973&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018e0973",
  null
  
)

export default component.exports